export const getLaunchStatus = (res) => {
    if (res.upcoming === true)
        return "Upcoming"
    else if (res.success === true)
        return "Success"
    else
        return "Failed"
}

export const getStatusColor = (res) => {
    if (res.upcoming === true)
        return "upcomingStatusColor"
    else if (res.success === true)
        return "successStatusColor"
    else
        return "failedStatusColor"
}

export const getLocation = (res) => {
    if (res.launchpad === '5e9e4502f5090995de566f86')
        return "Kwajalein Atoll"
    else if (res.launchpad === '5e9e4502f5090995de566f84')
        return "CCAFS SLC 40"
    else
        return "KSC LC 39A"
}